export default {
  props: {
    value: {},
    config: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    emit (value) {
      this.$emit('input', value)
    },
    haveErrors () {
      if (!this.config.errors) { return false }
      return this.config.errors
        .map(validator => validator(this.value))
        .filter(error => error)
        .length > 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/input.js